"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadManifest = void 0;
const manifest_domains_1 = __importDefault(require("./manifest-domains"));
const loadManifest = async (nodeEnv, manifestURL) => {
    const _manifestURL = (0, manifest_domains_1.default)(nodeEnv, manifestURL);
    if (window?.__APP_MANIFEST__?.federatedApps) {
        return window?.__APP_MANIFEST__?.federatedApps;
    }
    const manifest = await fetch(_manifestURL.latest).then(res => res.json()).catch(async (err) => {
        console.error("Failed to fetch latest manifest: ", err);
        if (_manifestURL.fallback) {
            const fallbackRes = await fetch(_manifestURL.fallback).then(res => res.json()).catch(err => {
                console.error("Failed to fetch fallback manifest: ", err);
                return {};
            });
            return fallbackRes;
        }
        return {};
    });
    window.__APP_MANIFEST__ = manifest;
    return window.__APP_MANIFEST__?.federatedApps;
};
exports.loadManifest = loadManifest;
//# sourceMappingURL=load-manifest.js.map